/* custom-cl-lang — behaviour for snippets/custom-cl-lang.liquid. Bound once per page (Theme Editor reloads never stack).
   - Desktop: the chip opens a non-modal <dialog> card. Esc, an outside click or Tab leaving it closes it; arrow keys move
     between languages; focus returns to the chip.
   - Options are real links (the phone menu turns them into one dropdown past four languages); every link carries the
     page's query string and hash; a choice is remembered.
   - Order: the visitor's own language first, English second, then the rank (Viktor 7 Oct 2026: "any country gets their
     local language first and english as second option always"). The server ordered the lists from localization.country;
     this re-reads the country from Shopify's `localization` cookie (a cached page never carries another visitor's
     order), and a visitor from outside every market, handed Bulgaria, gets their real country checked once per visit
     (/browsing_context_suggestions.json). Multilingual countries are settled by the browser's language. A country whose
     language is not on offer gets English first.
   - One quiet suggestion, only on the home language (Bulgarian) and only for visitors whose own language differs: a slim
     strip under the header in the page flow. The server renders it whenever it knows the answer (a shopper in a market);
     this only fills it for visitors from outside every market, and hides it once dismissed. Never a redirect, never a
     modal.
   - Phone menu: a Bulgarian shopper keeps today's menu (languages at the end); a visitor from abroad gets them first.
   - Ship to submits on change (the no-JS button sits in <noscript>).
   - Preview themes only: ?cl_lang_demo=1 lists every ranked language (unpublished ones as a demo that cannot navigate). */
(function () {
  if (window.__clLang) return;
  window.__clLang = true;
  var doc = document;
  var KEY = 'cl_lang';
  var HINT_OFF = 'cl_lang_hint_off';
  var GEO = 'cl_geo';
  var DEMO = 'cl_lang_demo';
  var MENU_MAX_PILLS = 4;

  function store(kind, k, v) {
    try {
      var s = kind === 'l' ? window.localStorage : window.sessionStorage;
      if (v === undefined) return s.getItem(k);
      s.setItem(k, v);
    } catch (e) { /* storage blocked: this page view still works */ }
    return null;
  }
  function head() { return doc.querySelector('[data-cl-lang][data-where="header"]'); }
  function parts(el) {
    var wrap = el && el.closest ? el.closest('[data-cl-lang][data-where="header"]') : null;
    return wrap ? { wrap: wrap, btn: wrap.querySelector('[data-cl-lang-btn]'), panel: wrap.querySelector('[data-cl-lang-panel]'), hint: wrap.querySelector('[data-cl-lang-hint]') } : null;
  }
  function suffix() { return window.location.search + window.location.hash; }

  // ---------- desktop card ----------
  // focus moves into the card only when it was opened from the keyboard (a mouse or tap open keeps focus on the chip,
  // so Safari draws no ring on the first row)
  function openPanel(p, fromKeyboard) {
    if (!p || !p.panel || p.panel.open) return;
    if (typeof p.panel.show === 'function') p.panel.show(); else p.panel.setAttribute('open', '');
    p.btn.setAttribute('aria-expanded', 'true');
    if (p.hint) p.hint.hidden = true;
    if (!fromKeyboard) { p.btn.focus({ preventScroll: true, focusVisible: false }); return; } // dialog.show() focuses its first link by itself
    var cur = p.panel.querySelector('.cl-lang__link[aria-current="true"]') || p.panel.querySelector('.cl-lang__link, select');
    if (cur) cur.focus({ preventScroll: true });
  }
  function closePanel(p, focusBtn) {
    if (!p || !p.panel || !p.panel.open) return;
    if (typeof p.panel.close === 'function') p.panel.close(); else p.panel.removeAttribute('open');
    p.btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) p.btn.focus({ preventScroll: true });
  }
  function isDemo(el) { return !!el && el.hasAttribute('data-demo'); }
  function hideHints() {
    doc.querySelectorAll('[data-cl-lang-hint]').forEach(function (h) { h.hidden = true; });
  }
  function markDemoChoice(iso) {
    doc.querySelectorAll('[data-cl-lang] a[data-iso]').forEach(function (a) {
      if (a.closest('[data-cl-lang-hint]')) return;
      if (a.getAttribute('data-iso') === iso) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    doc.querySelectorAll('[data-cl-lang-select]').forEach(function (s) {
      Array.prototype.forEach.call(s.options, function (o) { o.selected = o.getAttribute('data-iso') === iso; });
    });
    doc.querySelectorAll('.cl-lang__code').forEach(function (c) { c.textContent = iso.split('-')[0].toUpperCase(); });
    hideHints();
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-cl-lang-btn]');
    if (btn) {
      var p = parts(btn);
      if (p.panel.open) closePanel(p, false); else openPanel(p, e.detail === 0);
      return;
    }
    if (t.closest('[data-cl-lang-hint-x]')) {
      store('l', HINT_OFF, '1');
      hideHints();
      return;
    }
    var link = t.closest('[data-cl-lang] a[data-iso]');
    if (link) {
      var iso = link.getAttribute('data-iso');
      store('l', KEY, iso);
      if (isDemo(link)) {
        // preview only: an unpublished language has no pages yet, so show the choice instead of opening a 404
        e.preventDefault();
        markDemoChoice(iso);
        var hp = parts(head());
        if (hp) closePanel(hp, true);
      }
      return;
    }
    var open = doc.querySelector('[data-cl-lang-panel][open]');
    if (open && !t.closest('[data-cl-lang][data-where="header"]')) closePanel(parts(open), false);
  });

  doc.addEventListener('keydown', function (e) {
    var open = doc.querySelector('[data-cl-lang-panel][open]');
    if (!open) {
      if (e.key === 'ArrowDown' && doc.activeElement && doc.activeElement.matches && doc.activeElement.matches('[data-cl-lang-btn]')) {
        e.preventDefault();
        openPanel(parts(doc.activeElement), true);
      }
      return;
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      closePanel(parts(open), true);
      return;
    }
    var keys = { ArrowDown: 1, ArrowUp: -1, Home: 0, End: 0 };
    if (e.key === 'ArrowDown' && doc.activeElement && doc.activeElement.matches && doc.activeElement.matches('[data-cl-lang-btn]')) {
      var first = open.querySelector('.cl-lang__link[aria-current="true"]') || open.querySelector('.cl-lang__link');
      if (first) { e.preventDefault(); first.focus(); }
      return;
    }
    if (!(e.key in keys) || !doc.activeElement || !doc.activeElement.classList.contains('cl-lang__link')) return;
    var links = Array.prototype.slice.call(open.querySelectorAll('.cl-lang__link'));
    var i = links.indexOf(doc.activeElement);
    var n = e.key === 'Home' ? 0 : e.key === 'End' ? links.length - 1 : (i + keys[e.key] + links.length) % links.length;
    e.preventDefault();
    links[n].focus();
  });

  // Tab leaving the card closes it
  doc.addEventListener('focusout', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('[data-cl-lang][data-where="header"]') : null;
    if (!wrap) return;
    window.setTimeout(function () {
      var p = parts(wrap);
      if (p && p.panel && p.panel.open && !wrap.contains(doc.activeElement)) closePanel(p, false);
    }, 0);
  });
  // a <dialog> closed by the browser keeps aria-expanded honest
  doc.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cl-lang-panel]')) {
      var p = parts(e.target);
      if (p) p.btn.setAttribute('aria-expanded', 'false');
    }
  }, true);

  // Ship to submits on change; the menu's language dropdown goes to the same page in that language
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sel = t.closest('[data-cl-lang-country]');
    if (sel && sel.form) { sel.form.submit(); return; }
    var lang = t.closest('[data-cl-lang-select]');
    if (lang) {
      var o = lang.options[lang.selectedIndex];
      if (!o) return;
      var iso = o.getAttribute('data-iso');
      store('l', KEY, iso);
      if (isDemo(o)) { markDemoChoice(iso); return; }
      window.location.href = o.value + suffix();
    }
  });

  // ---------- every language link carries the current query string and hash ----------
  function syncLinks() {
    doc.querySelectorAll('[data-cl-lang] a[data-iso]').forEach(function (a) {
      if (isDemo(a)) return;
      if (!a.hasAttribute('data-href0')) a.setAttribute('data-href0', a.getAttribute('href'));
      a.setAttribute('href', a.getAttribute('data-href0') + suffix());
    });
  }

  // ---------- preview-only demo of the full list ----------
  function demoOn() {
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    if (role === 'main') return false;
    if (/[?&]cl_lang_demo=1\b/.test(window.location.search)) store('s', DEMO, '1');
    if (/[?&]cl_lang_demo=0\b/.test(window.location.search)) store('s', DEMO, '0');
    return store('s', DEMO) === '1';
  }
  function endonym(c) {
    var base = c.split('-')[0];
    try {
      var n = new Intl.DisplayNames([base], { type: 'language' }).of(base);
      return n ? n.charAt(0).toLocaleUpperCase(base) + n.slice(1) : c;
    } catch (e) { return c; }
  }
  // the phone menu shows pills up to four languages and one dropdown beyond that (same rule as the server)
  function pillsToSelect(list) {
    var wrap = list.closest('[data-cl-lang]');
    var label = wrap.querySelector('.cl-lang__label');
    var field = doc.createElement('span');
    field.className = 'cl-lang__ship-field';
    var sel = doc.createElement('select');
    sel.className = 'cl-lang__ship-select';
    sel.id = 'ClLangMenuSelect';
    sel.setAttribute('data-cl-lang-select', '');
    sel.setAttribute('data-cl-lang-list', '');
    Array.prototype.forEach.call(list.children, function (li) {
      var a = li.querySelector('a');
      var o = doc.createElement('option');
      o.value = a.getAttribute('data-href0') || a.getAttribute('href');
      o.textContent = a.textContent;
      o.setAttribute('data-iso', li.getAttribute('data-iso'));
      o.setAttribute('lang', li.getAttribute('data-iso'));
      if (isDemo(a)) o.setAttribute('data-demo', '');
      if (a.getAttribute('aria-current') === 'true') o.selected = true;
      sel.appendChild(o);
    });
    var caret = wrap.querySelector('.cl-lang__ship-caret');
    field.appendChild(sel);
    if (caret) field.appendChild(caret.cloneNode(true));
    list.replaceWith(field);
    if (label) {
      var l = doc.createElement('label');
      l.className = label.className;
      l.htmlFor = sel.id;
      l.textContent = label.textContent;
      label.replaceWith(l);
    }
  }
  function addDemo(w) {
    var rank = (w.getAttribute('data-rank') || '').split(',');
    doc.querySelectorAll('[data-cl-lang] [data-cl-lang-list]').forEach(function (list) {
      var have = {};
      Array.prototype.forEach.call(list.children, function (el) { have[el.getAttribute('data-iso')] = el; });
      var tpl = list.children[list.children.length - 1];
      if (!tpl) return;
      rank.forEach(function (c) {
        if (have[c]) return;
        var el = tpl.cloneNode(true);
        el.setAttribute('data-iso', c);
        if (el.tagName === 'OPTION') {
          el.value = '#' + c;
          el.selected = false;
          el.setAttribute('lang', c);
          el.setAttribute('data-demo', '');
          el.textContent = endonym(c);
        } else {
          var a = el.querySelector('a');
          a.setAttribute('data-iso', c);
          a.setAttribute('lang', c);
          a.setAttribute('hreflang', c);
          a.setAttribute('data-demo', '');
          a.setAttribute('href', '#' + c);
          a.removeAttribute('aria-current');
          a.removeAttribute('data-href0');
          (a.querySelector('.cl-lang__name') || a).textContent = endonym(c);
        }
        list.appendChild(el);
      });
      if (list.classList.contains('cl-lang__list') && list.children.length > 8) list.classList.add('cl-lang__list--two');
      if (list.classList.contains('cl-lang__chips') && list.children.length > MENU_MAX_PILLS) pillsToSelect(list);
    });
  }

  // ---------- the visitor's own language, second ----------
  function langsFor(cc, map) {
    var pairs = (map || '').split('|');
    for (var i = 0; i < pairs.length; i++) {
      var kv = pairs[i].split(':');
      if (kv[0] === cc) return (kv[1] || '').split(',');
    }
    return [];
  }
  function pick(cands, offered, home, cc, homeCc) {
    var avail = cands.filter(function (c) { return c && offered.indexOf(c) > -1; });
    if (avail.length > 1) {
      var prefs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < prefs.length; i++) {
        var p = String(prefs[i] || '').toLowerCase();
        for (var j = 0; j < avail.length; j++) {
          var c = avail[j].toLowerCase();
          if (c === p || c.split('-')[0] === p.split('-')[0]) return avail[j];
        }
      }
    }
    if (avail[0]) return avail[0];
    return offered.indexOf('en') > -1 ? 'en' : '';
  }
  function offeredOf(w) {
    return Array.prototype.map.call(w.querySelectorAll('[data-cl-lang-list] > li'), function (li) { return li.getAttribute('data-iso'); });
  }
  function reorder(w, own) {
    var home = w.getAttribute('data-home');
    var rank = (w.getAttribute('data-rank') || '').split(',');
    doc.querySelectorAll('[data-cl-lang] [data-cl-lang-list]').forEach(function (list) {
      var by = {};
      Array.prototype.forEach.call(list.children, function (el) { by[el.getAttribute('data-iso')] = el; });
      var order = [];
      if (own) order.push(own);
      if (own !== 'en') order.push('en');
      rank.concat(Object.keys(by)).forEach(function (c) {
        if (by[c] && order.indexOf(c) < 0) order.push(c);
      });
      order.forEach(function (c) { if (by[c]) list.appendChild(by[c]); });
    });
    doc.querySelectorAll('[data-cl-lang]').forEach(function (x) { x.setAttribute('data-local', own || ''); });
  }
  function detectedCountry() {
    var cached = store('s', GEO);
    if (cached !== null) return Promise.resolve(cached === '-' ? '' : cached);
    if (!window.fetch) return Promise.resolve('');
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, 3000);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return window.fetch(root.replace(/\/?$/, '/') + 'browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        window.clearTimeout(timer);
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        c = c ? String(c).toUpperCase() : '';
        store('s', GEO, c || '-');
        return c;
      }, function () {
        window.clearTimeout(timer);
        return '';
      });
  }
  function decide(w) {
    var home = w.getAttribute('data-home');
    var ck = doc.cookie.match(/(?:^|; )localization=([A-Z]{2})/);
    var cc = (ck && ck[1]) || w.getAttribute('data-cc') || '';
    var homeCc = w.getAttribute('data-home-cc') || '';
    var map = w.getAttribute('data-map');
    var countries = (w.getAttribute('data-countries') || '').split(',');
    var offered = offeredOf(w);
    var state = { cc: cc, detected: '', own: pick(langsFor(cc, map), offered, home, cc, homeCc), source: 'country' };
    // only a visitor carrying the home country can be someone from outside every market: nobody else costs a request
    if (!homeCc || cc !== homeCc) return Promise.resolve(state);
    return detectedCountry().then(function (dc) {
      state.detected = dc;
      if (dc && dc !== homeCc && countries.indexOf(dc) < 0) {
        state.own = pick(langsFor(dc, map), offered, home, dc, homeCc);
        state.source = 'outside-markets';
      }
      return state;
    });
  }

  // ---------- the quiet suggestion (a strip inside the header) ----------
  function hint(w, state) {
    var els = doc.querySelectorAll('[data-cl-lang-hint]');
    if (!els.length) return;
    var home = w.getAttribute('data-home');
    var chosen = store('l', KEY);
    if (store('l', HINT_OFF) || chosen === home || w.getAttribute('data-current') !== home) { hideHints(); return; }
    var target = chosen && w.querySelector('.cl-lang__link[data-iso="' + chosen + '"]:not([data-demo])') ? chosen : state.own;
    if (!target) { hideHints(); return; }
    var a = w.querySelector('.cl-lang__link[data-iso="' + target + '"]:not([data-demo])');
    if (!a) { hideHints(); return; }
    els.forEach(function (el) {
      var l = el.querySelector('[data-cl-lang-hint-link]');
      l.textContent = a.querySelector('.cl-lang__name').textContent.trim();
      l.setAttribute('data-href0', a.getAttribute('data-href0') || a.getAttribute('href'));
      l.setAttribute('href', a.getAttribute('href'));
      l.setAttribute('lang', target);
      l.setAttribute('hreflang', target);
      l.setAttribute('data-iso', target);
      el.hidden = false;
    });
  }
  // a visitor from outside every market arrives as Bulgaria: once we know, the menu leads with the languages
  function menuFirst() {
    var end = doc.querySelector('.cl-lang--menu-end');
    var slot = doc.querySelector('[data-cl-lang-menu-slot]');
    var nav = doc.getElementById('ClMobileMenu');
    if (!end || !slot || (nav && nav.getAttribute('aria-hidden') === 'false')) return;
    end.classList.remove('cl-lang--menu-end');
    slot.appendChild(end);
  }

  function init() {
    var w = head();
    if (w && demoOn()) addDemo(w);
    syncLinks();
    if (!w) return;
    decide(w).then(function (state) {
      if (state.own !== (w.getAttribute('data-local') || '')) reorder(w, state.own);
      state.order = offeredOf(w);
      window.__clLangState = state;
      if (state.source === 'outside-markets') menuFirst();
      hint(w, state);
      syncLinks();
    });
  }
  // Chart labels (10 Oct 2026): SVG text does not wrap, so a translated label longer than the English can run past its chart's
  // edge on a phone. Any label that leaves its <svg> is scaled down just enough to fit (never below 65 %); labels that fit, and
  // every English label, are untouched.
  function fitChartLabels() {
    var ts = doc.querySelectorAll('svg text');
    for (var i = 0; i < ts.length; i++) {
      var t = ts[i], s = t.ownerSVGElement;
      if (!s) continue;
      if (t.getAttribute('data-cl-fs0')) t.style.fontSize = '';
      var sr = s.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (sr.width < 2 || tr.width < 2) continue;
      var anchor = getComputedStyle(t).textAnchor, room;
      if (anchor === 'middle') { var c = (tr.left + tr.right) / 2; room = 2 * Math.min(c - sr.left, sr.right - c); }
      else if (anchor === 'end') room = tr.right - sr.left;
      else room = sr.right - tr.left;
      if (tr.width <= room + 1 || room <= 0) continue;
      var fs = parseFloat(getComputedStyle(t).fontSize);
      if (!fs) continue;
      t.setAttribute('data-cl-fs0', String(fs));
      t.style.fontSize = (fs * Math.max(0.65, (room - 4) / tr.width)) + 'px';
    }
  }
  var fitTimer;
  function fitSoon() { clearTimeout(fitTimer); fitTimer = setTimeout(fitChartLabels, 150); }
  window.addEventListener('load', fitChartLabels);
  window.addEventListener('resize', fitSoon);
  doc.addEventListener('shopify:section:load', fitSoon);
  window.addEventListener('hashchange', syncLinks);
  window.addEventListener('pageshow', syncLinks);
  doc.addEventListener('shopify:section:load', init);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
